/**
 * The browser's localStorage, limited to the three things allowed in it
 * (guide 5.3): the theme, the language, and each person's last branch.
 * Pharmacy data never goes here; tokens never go anywhere but memory.
 *
 * Every read and write may fail (a private window, storage switched off) and
 * then behaves as "nothing saved".
 */
export type StorageKey = "fb.theme" | "fb.locale" | `fb.branch.${string}`;

export function readSetting(key: StorageKey): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeSetting(key: StorageKey, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Not saved: it is only a convenience.
  }
}
